import type { SheetState } from '../../types';

/** Bottom offset for floating map chrome above the bottom sheet. */
export const MAP_SHEET_BOTTOM: Record<SheetState, string> = {
  minimized: 'calc(2vh + 0.5rem)',
  collapsed: 'calc(8vh + 0.5rem)',
  half: 'calc(40vh + 0.5rem)',
  expanded: 'calc(85vh + 0.5rem)',
};

/** Add-location panel snap — keeps zoom pill above the contribution sheet. */
export type ContributionSheetSnap = 'minimized' | 'compact' | 'half' | 'expanded';

export const CONTRIBUTION_SHEET_BOTTOM: Record<ContributionSheetSnap, string> = {
  minimized: 'calc(10vh + 0.5rem)',
  compact: 'calc(42vh + 0.5rem)',
  half: 'calc(65vh + 0.5rem)',
  expanded: 'calc(88vh + 0.5rem)',
};

/** Choropleth legend sits above zoom pill + attribution row. */
export const MAP_LEGEND_ABOVE_CHROME: Record<SheetState, string> = {
  minimized: 'calc(2vh + 0.5rem + 24px)',
  collapsed: 'calc(8vh + 0.5rem + 24px)',
  half: 'calc(40vh + 0.5rem + 24px)',
  expanded: 'calc(85vh + 0.5rem + 24px)',
};
